import { render, staticRenderFns } from "./RateFacilityPage.vue?vue&type=template&id=081fbd13&scoped=true&"
import script from "./RateFacilityPage.vue?vue&type=script&lang=js&"
export * from "./RateFacilityPage.vue?vue&type=script&lang=js&"
import style0 from "./RateFacilityPage.vue?vue&type=style&index=0&id=081fbd13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fbd13",
  null
  
)

export default component.exports